import React from 'react';
import '../getstated/getstart.css';
import { useTranslation } from "react-i18next";
// import lightLogo from '../../assets/images/light-logo.svg';

const Getstart = () => {
    const { t,i18n } = useTranslation();
    const currentLanguage = i18n.language;

    return (
        <div>
            <section className="get">
                {/* <img src={lightLogo} alt="baner-image" className='logo-white'/> */}
                {/* <div className="container">
                    <div className="get-content">
                        <div className="row align-items-center">
                            <div className="col-md-12 col-lg-7">
                                <div className="get-text">
                                    <h3 className="title"> Get Started Today</h3>
                                    <p>
                                    </p><p>Ready to find the perfect insurance coverage for you and your family? Get started now by
                                        entering your information and comparing quotes. At Suq Al Tamin, we're here to make
                                        insurance shopping simple, straightforward, and stress-free.</p>
                                    <p></p>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-5">
                                <div className="email-input">
                                    <div className="form-group">
                                        <input type="email" className="form-control" placeholder="Enter Email" id="mail" name="mail" />
                                    </div>
                                    <button className="btn btn-blue" type="button"><span>Subscribe</span><img src={require("../../assets/images/send.png")} alt="img" className="img-fluid" /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div className='container'>
                    <div className='get-text'>
                        <h3 style={{ transform: currentLanguage == 'ar' ? "scaleX(-1)" :  "scaleX(1)"  ,textAlign : currentLanguage == 'ar' ? 'right' : 'left'}}>{t('homeMainSlider.card3.title')}</h3>
                        <h4 style={{ transform: currentLanguage == 'ar' ? "scaleX(-1)" :  "scaleX(1)"  ,textAlign : currentLanguage == 'ar' ? 'right' : 'left'}}>{t('homeMainSlider.card3.subtitle')}</h4>
                    </div>
                </div>
            </section>
        </div>

    );
}

export default Getstart;